import cx from "classnames";
import { Suspense, lazy, memo } from "react";
import {
  PaymentElement,
  useElements,
  useStripe,
} from "@stripe/react-stripe-js";

import s from "./RetryPaymentWStripeFormPaymentForm.module.scss";
import stripeTrusted from "../../../../../../assets/images/wl-security-badge-stripe.png";
import useRetryPaymentWStripeFormStore, {
  SUBSCRIPTION_PRODUCT_NAME,
} from "../store";
import { bugNotif } from "../../../../../../api/bugsnag";
import { getErrorMsg } from "../../../../../../../Common/utils/common";
import { useFormsStore } from "../../../../../../../Common/store/common";
import { usePurchaseV2Store } from "../../../store";
import { WLButton } from "../../../../../../../Common/components/WLButton/WLButton";
import RetryPaymentsOrderSummary from "../../../RetryPaymentsOrderSummary/RetryPaymentsOrderSummary";
import { PAYMENT_ELEMENT_OPTIONS } from "../../../../../../../Common/constants/subscriptionConst";

const RetryPaymentWStripeFormPaymentForm = () => {
  const stripe = useStripe();
  const elements = useElements();

  const { selectedProduct, setError } = usePurchaseV2Store();
  const { clientSecretAndInvoiceToPay } = useRetryPaymentWStripeFormStore();
  const { setFormLoading } = useFormsStore();

  const retryPayment = async () => {
    setFormLoading(true);
    try {
      if (!stripe || !elements) {
        throw new Error("Form is not yet ready. Please try again.");
      }

      if (!selectedProduct) {
        throw new Error("No selected plan found. Please try again.");
      }

      if (!clientSecretAndInvoiceToPay) {
        throw new Error(
          "No transaction found. Please close this modal and try again."
        );
      }

      const { clientSecret } = clientSecretAndInvoiceToPay;

      const { error: submitError } = await elements.submit();
      if (submitError) {
        console.log({
          submitError,
        });
        setError(submitError.message || "");
        setFormLoading(false);
        return;
      }

      const currentUrl = window.location.href; // Gets the current page's URL
      const parsedUrl = new URL(currentUrl);
      const domain = parsedUrl.origin;
      const path = parsedUrl.pathname;
      const searchParams = parsedUrl.search;
      let returnUrl = `${domain}${path}${searchParams}${
        !searchParams ? "?" : "&"
      }${SUBSCRIPTION_PRODUCT_NAME}=${selectedProduct.name}`;

      const { error: errorPayment } = await stripe.confirmPayment({
        elements,
        clientSecret,
        confirmParams: {
          return_url: returnUrl,
        },
      });

      if (errorPayment) {
        throw new Error(errorPayment.message || "");
      }

      setFormLoading(false);
    } catch (error) {
      setFormLoading(false);
      const { errorMsg, rawErrorMsg } = getErrorMsg(error);
      setError(errorMsg);
      bugNotif("retryPayment - stripe Subscription", rawErrorMsg);
    }
  };
  return (
    <div className={s.container}>
      <div className={s.formContainer}>
        <PaymentElement
          className={s.paymentElement}
          options={PAYMENT_ELEMENT_OPTIONS}
        />
        <img className={s.stripeTrusted} src={stripeTrusted} alt="" loading="lazy" decoding="async" />
      </div>

      <div className={s.footer}>
        <Suspense>
          <RetryPaymentsOrderSummary mode="dialog" />
        </Suspense>
        <WLButton
          onClick={retryPayment}
          disabled={
            // must be disabled if no selected product, or can't be paid via card or a stripe payment element
            selectedProduct === undefined || !clientSecretAndInvoiceToPay
          }
          className={cx(
            s.confirmPurchaseBtn,
            "red-submit-button wl-body-6 ion-no-margin"
          )}
          isFormComponent
        >
          Fix my membership
        </WLButton>
      </div>
    </div>
  );
};

export default memo(RetryPaymentWStripeFormPaymentForm);
